import { Tabs, Tab } from "@mui/material";
import { useRouter } from "next/router";
import * as T from "common/src/bindings/Translation2";

export default function TlNav({ active }: { active: string }) {
  const router = useRouter();

  return (
    <div className="max-w-[100%]">
      <Tabs
        variant="scrollable"
        value={active}
        onChange={(_, tab) => {
          router.push(`/tier-list/${tab.toLowerCase()}`);
        }}
      >
        <Tab label={T.common("Units")} value="Units" />
        <Tab label={T.common("Traits")} value="Traits" />
        <Tab label={T.common("Items")} value="Items" />
        <Tab label={T.common("Augments")} value="Augments" />
        {/* <Tab label={T.common("Anomalies")} value="Anomalies" /> */}
      </Tabs>
    </div>
  );
}
